import clsx from 'clsx';
import React from 'react';
const TableCellSubtext = ({ children, className, style }) => (React.createElement("div", { className: clsx('font-color--grey--x-dark', 'text-xs', className), style: style }, children));
export default TableCellSubtext;
